module.exports = __webpack_public_path__ + "static/media/revision-material-bg-shape.275678e6.svg";